import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

// Utils
import useToggle from '@/utils/hooks/utils/useToggle';
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';
import { useUserGroupRestriction } from '@/utils/hooks/acl/useUserGroupRestriction';

// Components
import Button from '@/components/base/Button';
import { TooltipPlanRestriction } from '@/components/layouts/LayoutPlatform/components/Menu/components/TooltipPlanRestriction';
const SaveSelectedProfilesAsGroupModal = dynamic(() =>
    import('@/components/composite/SpGroups/SaveSelectedProfilesAsGroupModal').then(
        (mod) => mod.SaveSelectedProfilesAsGroupModal
    )
);

export function CreateGroupButton() {
    const { t } = useTranslation('layout_platform');
    const { isOpen, toggle } = useToggle<SocialProfileType[]>();

    const { hasGroupPermission } = useUserGroupRestriction();
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });
    const { activeMultiSelectionProfiles } = useProfilesStore((state) => state);

    return (
        <>
            <div>
                <TooltipPlanRestriction position="top" disabled={hasGroupPermission}>
                    <span className="inline-block">
                        <Button onClick={toggle} disabled={!hasGroupPermission} icon="plus">
                            {t('empty_states.multi_profiles.button')}
                        </Button>
                    </span>
                </TooltipPlanRestriction>
            </div>
            <SaveSelectedProfilesAsGroupModal
                isOpen={isOpen}
                toggle={toggle}
                selectedProfiles={activeMultiSelectionProfiles?.socialProfileIds?.map(
                    (id) => activatedSocialProfiles?.find((profile) => profile.id === id)
                )}
            />
        </>
    );
}
